import cx from 'classnames';

import styles from './MobilizeBadge.module.scss';

interface MobilizeBadgeProps {
	className?: string;
	size?: 'small' | 'large';
}

export const MobilizeBadge: React.FC<MobilizeBadgeProps> = ({ className, size = 'small' }) => (
	<div className={cx(styles.badge, { [styles.large]: size === 'large' }, className)}>
		<img alt="Mobilize" className={styles.logo} src="/static/images/mobilize-logo.png" />
	</div>
);
